/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactActivityBackfillResultDto } from '../models/ContactActivityBackfillResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ContactActivityBackfillService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Preview what the backfill would do for an org without writing anything.
     * @param orgGuid
     * @returns ContactActivityBackfillResultDto OK
     * @throws ApiError
     */
    public getApiComplianceContactActivityBackfillPreview(
        orgGuid: string,
    ): CancelablePromise<ContactActivityBackfillResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/compliance/ContactActivityBackfill/{orgGuid}/Preview',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Run the backfill for an org. Defaults to a dry run; pass dryRun=false to write rows.
     * @param orgGuid
     * @param dryRun
     * @returns ContactActivityBackfillResultDto OK
     * @throws ApiError
     */
    public postApiComplianceContactActivityBackfillRun(
        orgGuid: string,
        dryRun: boolean = true,
    ): CancelablePromise<ContactActivityBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/compliance/ContactActivityBackfill/{orgGuid}/Run',
            path: {
                'orgGuid': orgGuid,
            },
            query: {
                'dryRun': dryRun,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
